import script from "./ArticleCartInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleCartInput.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleCartInput.vue?vue&type=style&index=0&id=5f45127f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f45127f"]])

export default __exports__